import "../../App.scss";
import classes from "./NotFound.module.scss";
import React from "react";
import noise from "../../media/noise.png";
import icon from "../../media/404/icon.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <section className="section--1">
      <div className="circle circle--4"></div>
      <div className="circle circle--3"></div>
      <div className="circle circle--2"></div>
      <div className="circle circle--1"></div>
      <img src={noise} alt={"noise background"} className="noise" />
      <div className={classes["heading-container"]}>
        <div className={classes.heading}>
          <div className={classes.text}>
            <div className={classes["heading--blue"]}>
              <span>404</span>
              <img src={icon} alt="Dandruff" />
            </div>
            <div className={classes["heading--white"]}>{t("notFound.title")}</div>
          </div>
          <button onClick={() => navigate("/")} className={classes.button}>
            {t("notFound.button")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
